import "tailwindcss/tailwind.css";
import App from "./components/app";

export default App;
